<template>
    <div class="home-introduction">
        <b-skeleton-wrapper :loading="!homeSection.exists">
            <template #loading>
                <b-skeleton
                    width="85%"
                    class="mb-3"
                />
                <b-skeleton width="55%" />
                <b-skeleton width="70%" />
                <b-skeleton width="55%" />
                <b-skeleton width="85%" />
            </template>

            <p class="headline">
                {{ homeSection.headline }}
            </p>

            <p class="text">
                {{ homeSection.introduction }}
            </p>
        </b-skeleton-wrapper>
    </div>
</template>

<script>
    import './HomeIntroduction.scss';
    import LandingPageHomeSectionAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageHomeSectionAppResource";
    export default {
        name: "HomeIntroduction",
    
        props: {
            homeSection: {
                type: LandingPageHomeSectionAppResource,
                required: true,
            }
        }
    };
</script>
